document.addEventListener('DOMContentLoaded', function () {
  // Scroll to top function
  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // Move option variables to global scope
  var optionA = 0, optionB = 0, optionC = 0, optionD = 0, optionE = 0, optionF = 0;

  // Function to calculate scores based on VALUE attribute
  function calculateScores() {
    // Reset scores
    optionA = optionB = optionC = optionD = optionE = optionF = 0;
    
    // Get all checked inputs
    var checkedInputs = document.querySelectorAll("input:checked");
    
    // Count each letter in the value strings
    checkedInputs.forEach(function(input) {
      var value = input.value.toLowerCase();
      
      // Count occurrences of each letter
      for (var i = 0; i < value.length; i++) {
        switch(value[i]) {
          case 'a': optionA++; break;
          case 'b': optionB++; break;
          case 'c': optionC++; break;
          case 'd': optionD++; break;
          case 'e': optionE++; break;
          case 'f': optionF++; break;
        }
      }
    });

    // Debug logging
    console.log('Score calculation (VALUE-based):');
    console.log('option A: ' + optionA);
    console.log('option B: ' + optionB);
    console.log('option C: ' + optionC);
    console.log('option D: ' + optionD);
    console.log('option E: ' + optionE);
    console.log('option F: ' + optionF);

    // Update display elements if they exist
    if (document.querySelector('.optionA')) document.querySelector('.optionA').textContent = optionA;
    if (document.querySelector('.optionB')) document.querySelector('.optionB').textContent = optionB;
    if (document.querySelector('.optionC')) document.querySelector('.optionC').textContent = optionC;
    if (document.querySelector('.optionD')) document.querySelector('.optionD').textContent = optionD;
    if (document.querySelector('.optionE')) document.querySelector('.optionE').textContent = optionE;
    if (document.querySelector('.optionF')) document.querySelector('.optionF').textContent = optionF;
  }

  // Function to handle Klaviyo tracking for Question 12
  function handleKlaviyoTracking(input) {
    // Check if this is the Question 12 "art advisor" option
    if (input.id === 'q12a1' && input.checked) {
      // Initialize Klaviyo if not already done
      var _learnq = _learnq || [];
      
      // Send the custom property to Klaviyo
      _learnq.push(['identify', {
        'quiz_advisor': input.value // This will be "art_advisor"
      }]);
      
      console.log('Klaviyo quiz_advisor property set to:', input.value);
    }
  }

  // hidden things
  document.querySelectorAll('.q').forEach((q, index) => {
    if(index !== 0) q.style.display = 'none';
  })

  // next button
  var nextButtons = document.querySelectorAll(".next");
  nextButtons.forEach(function (nextButton) {
    nextButton.addEventListener('click', function () {
      // Calculate scores
      calculateScores();

      var getValue;
      this.parentNode.parentNode.querySelector('.options-container')
        .querySelectorAll(".option-block").forEach(op => { 
          if(op.classList.contains("active-option")) getValue = op.classList.contains("active-option") 
        });

      if (getValue) {
        var progressBar = document.getElementById("progressBar");
        if (progressBar) {
          var activeItem = Array.from(progressBar.querySelectorAll(".active")).at(-1);
          activeItem?.nextElementSibling?.classList?.add("active");
          activeItem?.previousElementSibling?.classList?.add("valid");
        }
        
        var alertBox = document.getElementById("alertBox");
        if (alertBox) alertBox.classList.add("d-none");
        
        this.closest('.main-content')?.querySelectorAll('.q').forEach(r => r.style.display = "none");
        var nextQuestion = this.closest(".q").nextElementSibling;
        if (nextQuestion) nextQuestion.style.display = "flex";
        
        this.classList.remove('notValid');
        
        // Scroll to top after successful next
        scrollToTop();
      } else {
        this.classList.add('notValid');
        document.documentElement.scrollTop = 0;
        var alertBox = document.getElementById("alertBox");
        if (alertBox) alertBox.classList.remove("d-none");
      }
    });
  });

  // back button
  var backButtons = document.querySelectorAll(".back");
  backButtons.forEach(function (backButton) {
    backButton.addEventListener('click', function () {
      var progressBar = document.getElementById("progressBar");
      if (progressBar) {
        var lastActive = progressBar.querySelector(".active:last-child");
        if (lastActive) lastActive.classList.remove("active");
      }
      
      this.closest('.main-content')?.querySelectorAll('.q').forEach(r => r.style.display = "none");
      var prevQuestion = this.closest(".row").previousElementSibling;
      if (prevQuestion) prevQuestion.style.display = "flex";
      
      // Scroll to top after going back
      scrollToTop();
    });
  });

  // finish button
  var submitButton = document.querySelector(".submit-button");
  submitButton?.addEventListener('click', function () {
    console.log('Submit button clicked');

    // Recalculate scores before determining result
    calculateScores();

    // Scroll to top before redirect
    scrollToTop();

    // Find the highest score
    var maxScore = Math.max(optionA, optionB, optionC, optionD, optionE, optionF);
    console.log('Max score: ' + maxScore);

    // If all scores are 0, default to organic
    if (maxScore === 0) {
      console.log('No answers selected, defaulting to organic');
      window.location.href = "https://www.tappancollective.com/pages/organic";
      return;
    }

    // Check for highest scoring option (check in order of preference for ties)
    if (optionA === maxScore && optionA > 0) {
      console.log('option A wins with score: ' + optionA);
      window.location.href = "https://www.tappancollective.com/pages/bookworm";
    } else if (optionB === maxScore && optionB > 0) {
      console.log('option B wins with score: ' + optionB);
      window.location.href = "https://www.tappancollective.com/pages/crisp-classic";
    } else if (optionC === maxScore && optionC > 0) {
      console.log('option C wins with score: ' + optionC);
      window.location.href = "https://www.tappancollective.com/pages/zen";
    } else if (optionD === maxScore && optionD > 0) {
      console.log('option D wins with score: ' + optionD);
      window.location.href = "https://www.tappancollective.com/pages/organic";
    } else if (optionE === maxScore && optionE > 0) {
      console.log('option E wins with score: ' + optionE);
      window.location.href = "https://www.tappancollective.com/pages/patron";
    } else if (optionF === maxScore && optionF > 0) {
      console.log('option F wins with score: ' + optionF);
      window.location.href = "https://www.tappancollective.com/pages/rebel";
    } else {
      // This should rarely happen now
      console.log('Fallback to organic');
      window.location.href = "https://www.tappancollective.com/pages/organic";
    }
  });

  // option-block click event
  var optionBlocks = document.querySelectorAll(".option-block");
  optionBlocks.forEach(function (optionBlock) {
    optionBlock.addEventListener('click', function (e) {
      var limit = this.parentElement;
      if (limit.classList.contains('limit2')) {
        var check = limit.querySelectorAll('input[type=checkbox]:checked').length;
        console.log('Checked boxes: ' + check);
        if (check > 2) {
          var only2Alert = document.querySelector('.only2options');
          if (only2Alert) only2Alert.classList.remove('d-none');
          limit.querySelectorAll('.option-block:not(.active-option)').forEach(function (el) {
            el.classList.add('disabled');
          });
        }
        if (check <= 2) {
          var only2Alert = document.querySelector('.only2options');
          if (only2Alert) only2Alert.classList.add('d-none');
          limit.querySelectorAll('.disabled').forEach(function (el) {
            el.classList.remove('disabled');
          });
        }
      }

      var qType = this.querySelector('input');
      if (!qType) return;

      if (qType.type === 'radio') {
        this.closest(".options-container").querySelectorAll(".option-block").forEach(function (el) {
          el.classList.remove("active-option");
        });
        this.classList.add("active-option");
        
        // Handle Klaviyo tracking for Question 12
        handleKlaviyoTracking(qType);
      }

      if (qType.type === 'checkbox') {
        if (qType.checked) {
          if (!this.classList.contains('disabled')) {
            this.classList.add("active-option");
            
            // Handle Klaviyo tracking for Question 12
            handleKlaviyoTracking(qType);
          } else {
            e.preventDefault();
          }
        } else {
          this.classList.remove("active-option");
        }
      }
    });
  });

  // back to wizard button
  var backToWizardButton = document.querySelector(".back-to-wizard");
  backToWizardButton?.addEventListener('click', function () {
    // Scroll to top before reloading
    scrollToTop();
    
    // Add a small delay to allow scroll animation to start
    setTimeout(() => {
      location.reload(true);
    }, 100);
  });
});